import { temAcesso } from '@/shared/auth/temAcesso'
const Etapas = () => import('./Etapas.vue')
const Etapa = () => import('./Etapa.vue')

export default [
    {
        path: 'etapas',
        name: 'Sgtec_Gerentes_Etapas',
        component: Etapas,
        beforeEnter: (to, from, next) => {
            if (temAcesso('SGTEC-GER-ETP-00')) {
                next()
            } else {
                console.error('Acesso negado à rota de etapas gerente. Permissão necessária: SGTEC-GER-ETP-00')
                next(false)
            }
        }
    },
    {
        path: 'etapas/:etapaId',
        name: 'Sgtec_Gerentes_Etapa_Detalhar',
        component: Etapa,
        beforeEnter: (to, from, next) => {
            if (temAcesso('SGTEC-GER-ETP-01')) {
                next()
            }
        }
    }
]
